exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-main[data-v-a849f596]{padding:0 .32rem}.sub_t[data-v-a849f596]{font-size:.18rem;font-weight:bold}", ""]);

// exports
